
/* eslint-disable */
import { defineComponent, ref, h } from 'vue'
import { mapActions, mapState } from 'vuex'
import {
  FilePdfOutlined,
  EyeOutlined,
  CloseOutlined,
  QuestionCircleOutlined,
  UnorderedListOutlined,
  CheckCircleOutlined,
  InfoCircleOutlined,
  CloseCircleOutlined,
  SolutionOutlined,
  MoreOutlined,
  DownloadOutlined
} from '@ant-design/icons-vue'
import { notification } from 'ant-design-vue'
import { eStatusEnvelope } from '@/services/enums/eStatusEnvelope'
import { EnvelopeService } from '@/services/EnvelopeService'
import { ListEnvelope } from '@/services/responses/ListEnvelopeResponse'
import { TokenService } from '@/services/TokenService'
import EnvelopeDetails from '@/views/home/details/index.vue'
// import { bind } from 'lodash'

export default defineComponent({
  name: 'DataTableOthersPendingSign',
  components: {
    FilePdfOutlined,
    EyeOutlined,
    CloseOutlined,
    QuestionCircleOutlined,
    UnorderedListOutlined,
    CheckCircleOutlined,
    InfoCircleOutlined,
    CloseCircleOutlined,
    SolutionOutlined,
    MoreOutlined,
    DownloadOutlined,
    EnvelopeDetails
  },
  computed: {
    ...mapState('sections', ['envelopesOthersPendingSign','isHome']),
    envelopsOthersPendingSign (): ListEnvelope[] {
      return this.envelopesOthersPendingSign !== null ? this.envelopesOthersPendingSign?.data : []
    }
  },
  data: () => ({
    visible: ref<boolean>(false),
    columns: [
      {
        title: 'Título',
        dataIndex: 'title',
        key: 'title',
        slots: { customRender: 'name' },
        fixed: 'center',
        resizable: true,
        width: 20,
        ellipsis: true
      },
      {
        title: 'Data',
        dataIndex: 'date',
        key: 'date',
        width: 8
      },
      {
        title: 'Progresso',
        key: 'progress',
        slots: { customRender: 'progress' },
        width: 15
      },
      {
        title: '',
        key: 'action',
        slots: { customRender: 'action' },
        width: 7
      }
    ],
    isShowDetailsDocument: ref<boolean>(false),
    detailsDocument: ref<any>([]),
    hashIdDocument: ref<any>(null),
    intervalReloadDatatable: ref<any>(1),
    interval: null as any
  }),

  watch: {
    intervalReloadDatatable: {
      handler(val) {
        this.fetchEnvelopesOthersPendingSign({ page: 1, size: 3, status: 6, limit: 3, filtered: null })
      },
      deep: true,
    },
  },

  mounted () {
    this.reloadDatatable()
  },

  unmounted () {
    clearInterval(this.interval)
  },
  methods: {
    ...mapActions('sections', [
        'fetchEnvelops',
        'fetchEnvelopesOthersPendingSign',
        'setOpenNewDocument'
    ]),
    reloadDatatable () {
        if (this.isHome) {
            this.interval = setInterval( function (this: any) {
                this.intervalReloadDatatable = Math.random()*100
            }.bind(this), 10000);
        }
    },
    getTeste (t: string) {
      return 'Teste'
    },
    handleResizeColumn (w: any, col: any) {
      col.width = w
    },
    progressColor (item: any) {
      const result = this.progressBar(item)
      if (item.status === eStatusEnvelope.CANCELED) return 'exception'
      if (item.status === eStatusEnvelope.PENDING) return 'active'
      if (result === 100) {
        return ''
      }
    },
    documentCanceled (item: any) {
      if (item.status === eStatusEnvelope.CANCELED) return false
      return true
    },
    progressBar (item: any): number {
      return parseFloat(
        ((item.startProgress / item.endProgress) * 100).toFixed(2)
      )
    },
    viewerDocument (item: ListEnvelope) {
      const url = `${process.env.VUE_APP_ROOT_VIEWER}/${
        item.hashId
      }?key=${TokenService.getToken()}&user=true`
      window.open(url, '_self')?.focus()
    },
    clearSpecialCharacters (text: any) {
      let noSpecials = text.replace(/[^\w\d\sáéíóúãõâêîôûàèìòù]/gi, " ")
	  let noMultipleSpaces = noSpecials.replace(/\s+/g, "_")
	  let uniqUnderscore = noMultipleSpaces.replace(/_+/g, "_")
	  return uniqUnderscore
    },
    async downDocument(item: ListEnvelope) {
      let hashId = item.hashId
      let responseEnvelope = await EnvelopeService.getInstance().getEnvelopeByHash(hashId)
 
      const res = await fetch(responseEnvelope.archive, 
        {
          mode: "cors",
          method: "GET",
          cache: "force-cache",
          headers: {
          Accept: "application/pdf",
        },
      })

      if (res.status === 200) {
        const blob = await res.blob()
        const a = document.createElement("a")
        a.style.display = "none"
        document.body.appendChild(a)
        a.href = window.URL.createObjectURL(blob)

        const fileName = this.clearSpecialCharacters(responseEnvelope.title)
        
        a.setAttribute("download", fileName)
        a.click()
        
        window.URL.revokeObjectURL(a.href)
        document.body.removeChild(a)
      } else {
        notification.error({
          message: 'Falha de Download',
          description: `Documento indisponível no momento. Por favor, entre em contato com o suporte para obter ajuda!`
        })
      }
    },
    async viewerDetailsDocument (record: ListEnvelope) {
      try {
        this.hashIdDocument = record.hashId
        this.detailsDocument = await EnvelopeService.getInstance().detailsEnvelope(record.hashId)
        this.isShowDetailsDocument = true 
      } catch (err) {}
    },
    async canceled (record: ListEnvelope) {
      try {
        await EnvelopeService.getInstance().cancelEnvelope(record.id)
        notification.success({
            message: 'Documento Cancelado',
            description: `O documento: ${record.title} foi cancelado.`
        })
      } catch (err) {}
    },
    titleStatus(item: any) {
      if (item?.status == 1 && item.partSigned) {
        return "Pendente"
      }
      if (item?.status == 1 ) {
        return "Pendente"
      }
      if (item?.status == 2) {
        return "Assinado"
      }
      if (item?.status == 3) {
        return "Cancelado"
      }
      if (item?.status == 5) {
        return "Observador"
      }
      return "Recusado"
    },
    closeModalDetails () {
      this.isShowDetailsDocument = false
    }
  }
})
